export interface IValidation {
    entityType: boolean,
    positions: boolean,
    firstName: boolean,
    lastName: boolean,
    email: boolean,
    primaryAddress: boolean,
    primaryAddressOverride: {
        street: boolean,
        city: boolean,
        state: boolean,
        postalCode: boolean
    },
    phoneNumbers: boolean,
    conferenceNumber: boolean,
    conferenceNumberCode: boolean,
    conferenceNumberMobileFriendly: boolean
}